import {
  FetchJaneByIdByIdDataProvider,
  useFetchJaneByIdDataContext,
} from 'modals/JaneDetailsModal/FetchJaneById.data.context';
import { JaneDetailsModalComponentMap } from './JaneDetailsModal.constants';
import {
  JaneDetailsModalUIProvider,
  useJaneDetailsModalUIContext,
} from 'modals/JaneDetailsModal/JaneDetailsModal.ui.context';
import { JaneDetailsModalTemplate } from './JaneDetailsModalTemplate';
import { FC, Fragment } from 'react';
import { useUserTypeSwitch } from 'hooks/useUserTypeSwitch';
import { CommunitySeniorityMethodProvider } from 'pages/TeamMembers/Internal/CommunitySeniorityMethod.context';

const ViewComponent: FC = () => {
  const { janeDetailsModalActiveModalView } = useJaneDetailsModalUIContext();
  const { data } = useFetchJaneByIdDataContext();

  const agencyId = data?.agencyCommunity?.id;
  const primaryId = data?.primaryCommunity?.id;
  const primaryJaneCommunityId = agencyId || primaryId;

  const Component = JaneDetailsModalComponentMap[
    janeDetailsModalActiveModalView
  ] as React.ComponentType;

  if (!primaryJaneCommunityId) {
    return <Fragment />;
  }

  return <Component />;
};

const JaneDetailsProviderComponent = () => {
  const { janeDetailsModalActiveModalView, janeId } = useJaneDetailsModalUIContext();
  const Component = JaneDetailsModalComponentMap[
    janeDetailsModalActiveModalView
  ] as React.ComponentType;

  if (!Component) return <Fragment />;

  return (
    <FetchJaneByIdByIdDataProvider janeId={janeId!}>
      <ViewComponent />
    </FetchJaneByIdByIdDataProvider>
  );
};

const JaneDetailsModalComponent = () => {
  return (
    <JaneDetailsModalTemplate>
      <JaneDetailsProviderComponent />
    </JaneDetailsModalTemplate>
  );
};

export const JaneDetailsModal = () => {
  return (
    <JaneDetailsModalUIProvider>
      {useUserTypeSwitch({
        Agency: <JaneDetailsModalComponent />,
        B2B: (
          <CommunitySeniorityMethodProvider>
            <JaneDetailsModalComponent />
          </CommunitySeniorityMethodProvider>
        ),
      })}
    </JaneDetailsModalUIProvider>
  );
};
